module.exports = __webpack_public_path__ + "static/media/icon-in-out.61794d3f.png";